import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import {
  NbDialogService,
  NbMediaBreakpointsService,
  NbMenuItem,
  NbMenuService,
  NbThemeService,
} from "@nebular/theme";
import { UserService } from "../../../@core/services/user.service";

import { DialogYesNoPromptComponent } from "../../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { find, remove, clone } from "lodash";

import { Router } from "@angular/router";

import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import { filter } from "rxjs/operators";
import Announcement from "../../../models/announcement.model";
import { AnnouncementService } from "../../../services/announcement.service";
import { DialogAnnouncementComponent } from "../../dialogs/dialog-announcement/dialog-announcement.component";

@Component({
  selector: "ngx-view-announcement",
  styleUrls: ["./view-announcement.component.scss"],
  templateUrl: "./view-announcement.component.html",
})
export class ViewAnnouncementComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() announcement: Announcement;
  @Input() mode?: string = "home"; //home / tutor / detail
  @Input() isMore? = false;
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() onEdit: EventEmitter<any> = new EventEmitter();

  loading = false;
  submitted = false;
  view = "question";
  uid = "";
  menuItems: NbMenuItem[] = [
    { title: "Chi tiết", icon: "external-link-outline" },
  ];
  isMobile = false;

  constructor(
    public userService: UserService,
    private announcementService: AnnouncementService,
    private dialogService: NbDialogService,
    private router: Router,
    private nbMenuService: NbMenuService,
    private breakpointService: NbMediaBreakpointsService,
    private themeService: NbThemeService
  ) {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
        } else {
          this.uid = "anonymous";
        }
      });

    const { sm } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < sm),
        takeUntil(this.destroy$)
      )
      .subscribe((isLessThanSm: boolean) => {
        this.isMobile = isLessThanSm;
      });
  }

  ngOnInit() {
    this.nbMenuService
      .onItemClick()
      .pipe(
        filter(({ tag }) => tag === `action-buttons-${this.announcement.id}`),
        map(({ item }) => item),
        takeUntil(this.destroy$)
      )
      .subscribe((item) => {
        switch (item.title) {
          case "Sửa":
            this.edit(item.data);
            break;
          case "Xóa":
            this.delete(item.data.id);
            break;
          case "Chi tiết":
            break;
          default:
            break;
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  reply() {
    this.view = "replies";
  }

  closeReply() {
    this.view = "main";
  }

  loadContent(value) {
    if (
      value &&
      (this.isMobile || this.announcement.sourceType == "document")
    ) {
      this.router.navigateByUrl(`/announcement/${this.announcement.id}`);
    }
    this.isMore = value;
  }

  loadButtonAction(item) {
    if (item.createdBy === this.uid) {
      this.menuItems = [
        { title: "Sửa", icon: "edit-2-outline", data: item },
        { title: "Xóa", icon: "trash-2-outline", data: { id: item.id } },
        {
          title: "Chi tiết",
          icon: "external-link-outline",
          link: `/announcement/${this.announcement.id}`,
        },
      ];
    } else {
      this.menuItems = [
        {
          title: "Chi tiết",
          icon: "external-link-outline",
          link: `/announcement/${this.announcement.id}`,
        },
      ];
    }
  }

  navigateRef(item) {
    if (item.courseId != "") {
      this.router.navigateByUrl(`/course/${item.courseId}`);
    } else if (item.quizId != "") {
      this.router.navigateByUrl(`/quiz/${item.quizId}`);
    }
  }

  tagSelected(tag) {
    console.log("tagSelected:", tag);
  }

  delete(id) {
    if (!this.submitted) {
      this.submitted = true;
      this.dialogService
        .open(DialogYesNoPromptComponent, {
          context: {
            title: "Bạn có chắc xóa nội dung này?",
          },
        })
        .onClose.subscribe((value) => {
          if (value) {
            this.loading = true;
            this.announcementService
              .delete(id)
              .then((result) => {
                this.loading = false;
                this.submitted = false;
                this.onDelete.emit(id);
              })
              .catch((err) => {
                this.loading = false;
                this.submitted = false;
              });
          }
          this.submitted = false;
        });
    }
  }

  edit(item: Announcement) {
    let lecBk = new Announcement();
    lecBk = clone(item);
    this.dialogService
      .open(DialogAnnouncementComponent, {
        context: {
          header: "Cập nhật bài viết",
          mode: "edit",
          announcement: lecBk,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          item = value;
          this.announcement = value;
          this.onEdit.emit(value);
        }
      });
  }
}
